import injectSheet from "react-jss";
import styles from "../draggablelist_styles";

//icons
import { ReactComponent as DragDrop } from 'assets/icons/dragdrop.svg';
import { ReactComponent as Close } from "assets/icons/dismiss.svg";

const DraggableListItem = injectSheet(styles)((props) => {
    const {label, innerRef, provided , handleDeletion , item} = props;

    const handleRemoval =() => {
        handleDeletion(item);
    }

    return (
        <span className={`sortableitem draggableitem ${props.classes.sortableItem}`} ref={innerRef} {...provided.draggableProps} {...provided.dragHandleProps}>
                        <div className={`singleitem ${props.classes.singleItem}`}>
                            <div className={`drag-icon ${props.classes.icon}`}>
                                <DragDrop></DragDrop>
                            </div>
                            <div className={`singleitemlabel ${props.classes.singleItemLabel}`}>
                                <label className={`itemlabel ${props.classes.itemLabel}`}>{label}</label>
                            </div>
                            <div className={`removeitem ${props.classes.removeItem}`}>
                                <button onClick={handleRemoval}>
                                    <span>
                                       <Close></Close>
                                    </span>
                                </button>
                            </div>
                        </div>

        </span>
    )
});

export default DraggableListItem;